import { functionDoc } from '../functionDoc';
import { ROLES, SHOTS } from '../docHelpers';

/** Documentación detallada (plantilla 12 apartados) — Producción concesionaria. */
export const produccionConcesionariaSections = [
  functionDoc({
    id: "pc-area-despacho",
    name: "Área de despacho",
    type: "form",
    route: "/produccion-concesionaria/configuraciones/area-despacho",
    locationPath: "Producción concesionaria > Configuración > Área de despacho",
    generalDescription: "Catálogo de destinos del comedor (línea caliente, ensaladera, etc.) usados como filas en el cuadro de venta producción.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Nombre del área",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Etiqueta en cuadro y reportes.",
        "behavior": ""
      },
      {
        "name": "Cliente asociado",
        "controlType": "Campo",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Opcional si el destino factura distinto.",
        "behavior": ""
      }
    ],
    procedure: [
      "Configuración → Área de despacho.",
      "Nuevo.",
      "Complete nombre.",
      "Guarde."
    ],
    practicalExample: "Crear área «Línea caliente».",
    validations: [
      "Nombre único en el POS operativo."
    ],
    expectedResult: [
      "Área disponible al armar filas del día."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-cuadro-plantilla",
      "pc-produccion-dia"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.listado, SHOTS.formularioCompleto],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.concesionariaVentaOperacionesEnabled || ctx.settings.produccionConcesionariaEnabled,
  }),
  functionDoc({
    id: "pc-cuadro-plantilla",
    name: "Cuadro venta — plantillas y columnas",
    type: "config",
    route: "/produccion-concesionaria/configuraciones/cuadro-venta",
    locationPath: "Producción concesionaria > Configuración > Cuadro venta",
    generalDescription: "Define plantillas por POS: columnas numéricas, rutas OSV/efectivo, cliente OSV, proyecto y mapeo comida→servicio de ventas.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Plantilla y POS",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Cabecera de configuración.",
        "behavior": ""
      },
      {
        "name": "Columnas",
        "controlType": "Grilla",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Etiqueta, orden y ruta de venta.",
        "behavior": ""
      },
      {
        "name": "Cliente OSV y proyecto",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Destino de OSV al confirmar.",
        "behavior": ""
      },
      {
        "name": "Mapeo comida/servicio",
        "controlType": "Grilla",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Precio y servicio facturable.",
        "behavior": ""
      }
    ],
    procedure: [
      "Cuadro venta → nueva plantilla.",
      "Asigne POS.",
      "Defina columnas activas.",
      "Complete cliente OSV y mapeos.",
      "Guarde y pruebe en venta producción."
    ],
    practicalExample: "Plantilla «Turno día» con columnas Producido y Q con ticket.",
    validations: [
      "Columnas OSV suman control de merma.",
      "Efectivo agrupa ventas a CLIENTES VARIOS."
    ],
    expectedResult: [
      "Plantilla lista para cuadros diarios."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-produccion-dia",
      "pc-dashboard-venta"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.formularioCompleto],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.concesionariaVentaOperacionesEnabled,
  }),
  functionDoc({
    id: "pc-produccion-dia",
    name: "Venta producción — cuadro del día",
    type: "form",
    route: "/produccion-concesionaria/operaciones/produccion-dia",
    locationPath: "Producción concesionaria > Venta producción",
    generalDescription: "Grilla diaria: requerimiento, columnas de producción, merma; confirmar genera OSV y ventas; revertir anula documentos.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Plantilla y fecha",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Identifica el sheet del día.",
        "behavior": ""
      },
      {
        "name": "Filas área + comida",
        "controlType": "Grilla",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Requerimiento y columnas numéricas.",
        "behavior": ""
      },
      {
        "name": "Confirmar venta / Revertir",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Genera o anula documentos.",
        "behavior": ""
      },
      {
        "name": "Historial mensual",
        "controlType": "Tabla",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Cuadros del período.",
        "behavior": ""
      }
    ],
    procedure: [
      "Elija plantilla y fecha.",
      "Agregue filas con área y comida.",
      "Complete columnas.",
      "Revise merma y diferencia.",
      "Guarde borrador o confirme."
    ],
    practicalExample: {
      "data": {
        "Comida": "POLLO CHICLAYANA",
        "Requerimiento": "120"
      },
      "steps": [
        "Cargue fila",
        "Confirme al cierre"
      ]
    },
    validations: [
      "Confirmar irreversible salvo revertir autorizado."
    ],
    expectedResult: [
      "OSV y ventas creadas al confirmar."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-dashboard-venta",
      "pc-cuadro-plantilla"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.formularioCompleto, SHOTS.confirmacion],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.concesionariaVentaOperacionesEnabled,
  }),
  functionDoc({
    id: "pc-dashboard-venta",
    name: "Dashboard venta producción",
    type: "report",
    route: "/produccion-concesionaria/operaciones/venta-produccion-dashboard",
    locationPath: "Producción concesionaria > Dashboard venta producción",
    generalDescription: "Análisis de cuadros confirmados: por plantilla, POS, general o comparación; KPIs de merma, producción y venta S/.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Pestañas de modo",
        "controlType": "Tabs",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Plantilla, POS, general, comparar.",
        "behavior": ""
      },
      {
        "name": "Filtros fecha",
        "controlType": "Fechas",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Rango de análisis.",
        "behavior": ""
      },
      {
        "name": "Gráficos",
        "controlType": "Dashboard",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Producción, merma, efectivo.",
        "behavior": ""
      }
    ],
    procedure: [
      "Abra dashboard.",
      "Elija modo y filtros.",
      "Actualice."
    ],
    practicalExample: "Comparar merma entre dos POS del mes.",
    validations: [
      "Solo cuadros confirmados en agregados."
    ],
    expectedResult: [
      "Indicadores y gráficos actualizados."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-produccion-dia"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.vistaGeneral],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.concesionariaVentaOperacionesEnabled,
  }),
  functionDoc({
    id: "pc-planeamiento-ciclicos",
    name: "Planeamiento — cíclicos",
    type: "list",
    route: "/produccion-concesionaria/planeamiento/ciclicos",
    locationPath: "Producción concesionaria > Planeamiento > Cíclicos",
    generalDescription: "Listado de ciclos de planeamiento recurrente; base para salidas y despacho de producción concesionaria clásica.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Tabla ciclos",
        "controlType": "Tabla",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Período y estado.",
        "behavior": ""
      },
      {
        "name": "Nuevo cíclico",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Alta de plan.",
        "behavior": ""
      }
    ],
    procedure: [
      "Planeamiento → Cíclicos.",
      "Consulte o cree ciclo."
    ],
    practicalExample: "Ciclo semanal comedor mina.",
    validations: [
      "Visible según flags de planeamiento."
    ],
    expectedResult: [
      "Acceso a detalle de ciclo."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-planeamiento-plantillas",
      "pc-salidas-produccion"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.listado],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.produccionConcesionariaEnabled && (ctx.settings.produccionConcesionariaPlaneamientoEnabled || !ctx.settings.concesionariaVentaOperacionesEnabled),
  }),
  functionDoc({
    id: "pc-planeamiento-plantillas",
    name: "Planeamiento — plantillas cíclicas",
    type: "config",
    route: "/produccion-concesionaria/planeamiento/plantillas-ciclicos",
    locationPath: "Producción concesionaria > Planeamiento > Plantillas cíclicas",
    generalDescription: "Plantillas maestras para generar planes por período sin cuadro venta-operaciones.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Plantilla cíclica",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Nombre y reglas de repetición.",
        "behavior": ""
      },
      {
        "name": "Detalle menú / platos",
        "controlType": "Grilla",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Contenido del ciclo.",
        "behavior": ""
      }
    ],
    procedure: [
      "Abra plantillas cíclicas.",
      "Cree o edite.",
      "Genere cíclicos del período."
    ],
    practicalExample: "Plantilla «Menú 4 semanas».",
    validations: [
      "Requiere módulo planeamiento habilitado."
    ],
    expectedResult: [
      "Plantillas listas para generar ciclos."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-planeamiento-ciclicos"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.vistaGeneral],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.produccionConcesionariaEnabled && (ctx.settings.produccionConcesionariaPlaneamientoEnabled || !ctx.settings.concesionariaVentaOperacionesEnabled),
  }),
  functionDoc({
    id: "pc-ciclico-nuevo",
    name: "Planeamiento — nuevo cíclico",
    type: "form",
    route: "/produccion-concesionaria/planeamiento/ciclicos/nuevo",
    locationPath: "Producción concesionaria > Planeamiento > Nuevo cíclico",
    generalDescription: "Formulario para abrir un ciclo de planeamiento a partir de plantilla y fechas.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Plantilla origen",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Selección de plantilla cíclica.",
        "behavior": ""
      },
      {
        "name": "Fechas del ciclo",
        "controlType": "Fechas",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Inicio y fin.",
        "behavior": ""
      }
    ],
    procedure: [
      "Cíclicos → Nuevo.",
      "Elija plantilla.",
      "Defina fechas.",
      "Guarde."
    ],
    practicalExample: "Generar ciclo del 1 al 7 del mes.",
    validations: [
      "No solapar ciclos activos si el sistema lo impide."
    ],
    expectedResult: [
      "Ciclo creado en listado."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-ciclico-detalle"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.formularioCompleto],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.produccionConcesionariaEnabled && (ctx.settings.produccionConcesionariaPlaneamientoEnabled || !ctx.settings.concesionariaVentaOperacionesEnabled),
  }),
  functionDoc({
    id: "pc-ciclico-detalle",
    name: "Planeamiento — detalle de cíclico",
    type: "screen",
    route: "/produccion-concesionaria/planeamiento/ciclicos/1",
    locationPath: "Producción concesionaria > Planeamiento > Detalle cíclico",
    generalDescription: "Vista del ciclo: días, menús planificados y enlaces a operaciones de salida y despacho.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Calendario / días",
        "controlType": "Panel",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Estructura del ciclo.",
        "behavior": ""
      },
      {
        "name": "Acciones por día",
        "controlType": "Enlaces",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Ir a salidas o despacho.",
        "behavior": ""
      }
    ],
    procedure: [
      "Abra ciclo desde listado.",
      "Revise días.",
      "Acceda a operaciones del día."
    ],
    practicalExample: "Revisar menú del miércoles antes de producción.",
    validations: [
      "ID de ciclo debe existir."
    ],
    expectedResult: [
      "Plan visible por día."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-salidas-detalle",
      "pc-despacho-detalle"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.vistaGeneral],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.produccionConcesionariaEnabled && (ctx.settings.produccionConcesionariaPlaneamientoEnabled || !ctx.settings.concesionariaVentaOperacionesEnabled),
  }),
  functionDoc({
    id: "pc-salidas-produccion",
    name: "Operaciones almacén — salidas a producción",
    type: "list",
    route: "/produccion-concesionaria/operaciones/salidas-produccion",
    locationPath: "Producción concesionaria > Operaciones > Salidas producción",
    generalDescription: "Registro de salidas de almacén hacia producción del comedor según ciclo o día operativo.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Listado por ciclo/día",
        "controlType": "Tabla",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Salidas pendientes y completadas.",
        "behavior": ""
      },
      {
        "name": "Registrar salida",
        "controlType": "Enlace",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Detalle del día.",
        "behavior": ""
      }
    ],
    procedure: [
      "Operaciones → Salidas producción.",
      "Elija ciclo y día.",
      "Complete cantidades."
    ],
    practicalExample: "Salida de insumos para cocina central.",
    validations: [
      "Stock en almacén de producción."
    ],
    expectedResult: [
      "Salidas registradas en inventario."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-salidas-detalle",
      "pc-despacho-index"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.listado],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.produccionConcesionariaEnabled && (ctx.settings.concesionariaOperacionesAlmacenEnabled || !ctx.settings.concesionariaVentaOperacionesEnabled),
  }),
  functionDoc({
    id: "pc-salidas-detalle",
    name: "Salidas a producción — detalle del día",
    type: "form",
    route: "/produccion-concesionaria/operaciones/salidas-produccion/ciclo/1/dia/2026-01-01",
    locationPath: "Producción concesionaria > Salidas > Detalle día",
    generalDescription: "Captura líneas de salida de insumos para un día específico del ciclo de planeamiento.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Productos y cantidades",
        "controlType": "Grilla",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Grilla de salida.",
        "behavior": ""
      },
      {
        "name": "Confirmar",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Aplica movimiento de almacén.",
        "behavior": ""
      }
    ],
    procedure: [
      "Entre al día desde listado.",
      "Complete cantidades.",
      "Confirme."
    ],
    practicalExample: "Salida de verduras del almacén seco.",
    validations: [
      "Cantidades positivas y stock disponible."
    ],
    expectedResult: [
      "Guías o movimientos de salida generados."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-salidas-produccion"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.formularioCompleto],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.produccionConcesionariaEnabled && (ctx.settings.concesionariaOperacionesAlmacenEnabled || !ctx.settings.concesionariaVentaOperacionesEnabled),
  }),
  functionDoc({
    id: "pc-despacho-index",
    name: "Operaciones almacén — despacho",
    type: "list",
    route: "/produccion-concesionaria/operaciones/despacho",
    locationPath: "Producción concesionaria > Operaciones > Despacho",
    generalDescription: "Despacho de producto terminado desde almacén hacia puntos del comedor según plan.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Listado despachos",
        "controlType": "Tabla",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Por ciclo y día.",
        "behavior": ""
      },
      {
        "name": "Detalle día",
        "controlType": "Enlace",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Captura de despacho.",
        "behavior": ""
      }
    ],
    procedure: [
      "Operaciones → Despacho.",
      "Seleccione día.",
      "Registre despacho PT."
    ],
    practicalExample: "Despacho de pan al comedor B.",
    validations: [
      "Requiere producción previa o stock PT."
    ],
    expectedResult: [
      "Despachos registrados."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-despacho-detalle",
      "pc-salidas-produccion"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.listado],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.produccionConcesionariaEnabled && (ctx.settings.concesionariaOperacionesAlmacenEnabled || !ctx.settings.concesionariaVentaOperacionesEnabled),
  }),
  functionDoc({
    id: "pc-despacho-detalle",
    name: "Despacho — detalle del día",
    type: "form",
    route: "/produccion-concesionaria/operaciones/despacho/ciclo/1/dia/2026-01-01",
    locationPath: "Producción concesionaria > Despacho > Detalle día",
    generalDescription: "Formulario de despacho de PT hacia áreas de consumo para un día del ciclo.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Líneas de despacho",
        "controlType": "Grilla",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Producto PT y cantidad por destino.",
        "behavior": ""
      },
      {
        "name": "Confirmar despacho",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Reduce stock PT y registra entrega.",
        "behavior": ""
      }
    ],
    procedure: [
      "Abra detalle del día.",
      "Complete destinos y cantidades.",
      "Confirme."
    ],
    practicalExample: "Despachar 200 raciones al comedor principal.",
    validations: [
      "Stock PT suficiente."
    ],
    expectedResult: [
      "Movimiento de salida PT registrado."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-despacho-index"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.formularioCompleto, SHOTS.confirmacion],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.settings.produccionConcesionariaEnabled && (ctx.settings.concesionariaOperacionesAlmacenEnabled || !ctx.settings.concesionariaVentaOperacionesEnabled),
  }),
  functionDoc({
    id: "pc-inicio",
    name: "Inicio producción concesionaria",
    type: "screen",
    route: "/produccion-concesionaria",
    locationPath: "Producción concesionaria > Inicio",
    generalDescription: "Página de bienvenida con accesos a configuración, venta producción, planeamiento y operaciones de almacén según flags activos.",
    prerequisites: [
      "Módulo producción concesionaria o venta-operaciones habilitado.",
      "POS y plantillas configurados para cuadro diario."
    ],
    interfaceElements: [
      {
        "name": "Accesos rápidos",
        "controlType": "Tarjetas",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Enlaces según módulos habilitados.",
        "behavior": ""
      }
    ],
    procedure: [
      "Menú Producción concesionaria.",
      "Elija el flujo operativo del día."
    ],
    practicalExample: "Operador entra directo a Venta producción.",
    validations: [
      "Ítems ocultos si el flag correspondiente está apagado."
    ],
    expectedResult: [
      "Navegación coherente con el menú lateral."
    ],
    commonErrors: [
      {
        "error": "No se puede confirmar cuadro",
        "cause": "Falta mapeo comida-servicio o cliente OSV en plantilla.",
        "solution": "Complete configuración de cuadro venta."
      }
    ],
    relatedFunctions: [
      "pc-produccion-dia",
      "pc-area-despacho"
    ],
    observations: [ROLES.limitado, "La confirmación del cuadro genera documentos de ventas automáticamente."],
    screenshots: [SHOTS.vistaGeneral],
    roles: ROLES.concesionaria,
    isVisible: (ctx) => ctx.canSeeProduccionConcesionaria,
  }),
];
